import axiosInstance from "./axiosInstance";

const APP_BASE_URL = process.env.REACT_APP_API_URL || "";

/**
 * Calls the Playwright runner /run-ui endpoint.
 * @param {"Volume"|"NonVolume"} [params.productType]
 * @param {boolean} [params.excludeSFDC]
 * @param {File} [params.file] - uploaded Excel/CSV file from the dashboard
 */
export async function submitRun({ productType, file, excludeSFDC }) {
  if (!APP_BASE_URL) {
    throw new Error("APP_BASE_URL is not configured");
  }

  const formData = new FormData();

  if (productType === "Volume") {
    formData.append("flow", "tier");
  } else {
    formData.append("flow", "nontier");
  }

  if (file) {
    formData.append("file", file, file.name);
  }

  formData.append("excludeSFDC", excludeSFDC);

  const url = "/api/v1/playwright/run";

  try {
    const htmlResponse = await axiosInstance.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "arraybuffer",
    });

    // Decode binary HTML to string
    const reportHtml = new TextDecoder().decode(htmlResponse.data);

    return { status: htmlResponse.status, html: reportHtml };
  } catch (error) {
    console.error("Error submitting run: ", error);

    // Handle 400 error and extract detail from response
    if (error.response?.status === 400) {
      let errorDetail = "Bad Request";

      // Check if response data exists and is ArrayBuffer
      if (error.response.data && error.response.data instanceof ArrayBuffer) {
        try {
          // Convert ArrayBuffer to string
          const decoder = new TextDecoder();
          const responseText = decoder.decode(error.response.data);

          // Try to parse as JSON to get the detail field
          try {
            const errorData = JSON.parse(responseText);
            errorDetail = errorData.detail || errorData.message || responseText;
          } catch {
            // If not JSON, use the raw text
            errorDetail = responseText;
          }
        } catch {
          errorDetail = "Error processing response";
        }
      }
      // If data is not ArrayBuffer, try to get detail directly
      else if (error.response.data?.detail) {
        errorDetail = error.response.data.detail;
      } else if (error.response.data?.message) {
        errorDetail = error.response.data.message;
      }

      // Throw error with the extracted detail
      throw new Error(errorDetail);
    }
    throw error;
  }
}
